export const data = [
  { time: 'M01', value: 0, type: 'mercuryUsed' },
  { time: 'M02', value: 0, type: 'mercuryUsed' },
  { time: 'M03', value: 0, type: 'mercuryUsed' },
  { time: 'M04', value: 0, type: 'mercuryUsed' },
  { time: 'M05', value: 0, type: 'mercuryUsed' },
  { time: 'M06', value: 0, type: 'mercuryUsed' },
  { time: 'M07', value: 0, type: 'mercuryUsed' },
  { time: 'M08', value: 0, type: 'mercuryUsed' },
  { time: 'M09', value: 0, type: 'mercuryUsed' },
  { time: 'M10', value: 0, type: 'mercuryUsed' },
  { time: 'M11', value: 0, type: 'mercuryUsed' },
  { time: 'M12', value: 0, type: 'mercuryUsed' },

  { time: 'M01', value: 0, type: 'goldProduced' },
  { time: 'M02', value: 0, type: 'goldProduced' },
  { time: 'M03', value: 0, type: 'goldProduced' },
  { time: 'M04', value: 0, type: 'goldProduced' },
  { time: 'M05', value: 0, type: 'goldProduced' },
  { time: 'M06', value: 0, type: 'goldProduced' },
  { time: 'M07', value: 0, type: 'goldProduced' },
  { time: 'M08', value: 0, type: 'goldProduced' },
  { time: 'M09', value: 0, type: 'goldProduced' },
  { time: 'M10', value: 0, type: 'goldProduced' },
  { time: 'M11', value: 0, type: 'goldProduced' },
  { time: 'M12', value: 0, type: 'goldProduced' },
];

